import wx from "weixin-js-sdk";
import { getWechatConfig } from "@/api/wechat";
// import { addUserViewsRecords } from "@/api/user";

export default (
  title = "2025脑健康大会",
  desc = "欢迎各位来宾参会！",
  link = location.origin,
  imgUrl = "https://ntppc.oss-cn-shanghai.aliyuncs.com/mp4/20240719a7omop5q.png"
) => {
  const _initSdk = async () => {
    // 分享链接记录  路由 -> 记录key
    // let sharePageObj = {
    //   play: "columnShare",
    //   patienteducationdetail: "peShare",
    //   caseList: "caseShare",
    //   caseHome: "caseShareList",
    //   MemberDay: "MemberDayShare",
    // };

    const { results } = await getWechatConfig({
      url: location.href,
      source: process.env.NODE_ENV == "production" ? "YM_NERVE" : "YM_PM", // 测试在源墨医学科技、正式在脑健康
    });
    const { nonceStr, signature, timestamp, appId } = results;
    // 配置
    wx.config({
      // debug: true, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
      appId, // 必填，公众号的唯一标识
      timestamp, // 必填，生成签名的时间戳
      nonceStr, // 必填，生成签名的随机串
      signature, // 必填，签名
      jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage", "scanQRCode"], // 必填，需要使用的 JS 接口列表
      openTagList: ["wx-open-launch-weapp"],
    });

    // 成功
    wx.ready(function () {
      console.log("初始化成功");
      // 分享给某人
      wx.onMenuShareTimeline({
        title, // 分享标题
        desc, // 分享描述
        link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
        imgUrl, // 分享图标
        success: function () {
          // for (let i in sharePageObj) {
          //   if (location.pathname.indexOf(i) >= 0) {
          //     // 保存分享记录
          //     addUserViewsRecords({
          //       linkKey: sharePageObj[i],
          //       linkUrl: link,
          //     });
          //   }
          // }
        },
      });
      // 分享到朋友圈
      wx.onMenuShareAppMessage({
        title, // 分享标题
        desc, // 分享描述
        link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
        imgUrl, // 分享图标
        success: function () {
          // for (let i in sharePageObj) {
          //   if (location.pathname.indexOf(i) >= 0) {
          //     // 保存分享记录
          //     addUserViewsRecords({
          //       linkKey: sharePageObj[i],
          //       linkUrl: link,
          //     });
          //   }
          // }
        },
      });
    });

    // 分享失败
    wx.error(function (res) {
      console.log("wechat sdk error", res);
    });
  };
  _initSdk();
};
